import type { DocumentTableActionsDropdownMenuFragment } from "../client/generated";
import { Icon } from "@mdi/react";
import { mdiDotsVertical } from "@mdi/js";
import { DocumentRenameDropdownMenuItem } from "./DocumentRenameDropdownMenuItem";
import { DocumentExportDropdownMenuItem } from "./DocumentExportDropdownMenuItem";
import { DocumentDeleteDropdownMenuItem } from "./DocumentDeleteDropdownMenuItem";
import { DocumentShareDropdownMenuItem } from "./DocumentShareDropdownMenuItem";
import { DocumentTagsDropdownMenuItem } from "./DocumentTagsDropdownMenuItem";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@acdc2/ui/components/dropdown-menu";

type Props = {
  fragment: DocumentTableActionsDropdownMenuFragment;
};

export function DocumentTableActionsDropdownMenu({ fragment }: Props) {
  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger
          data-testid="document-actions-dropdown-menu"
          asChild
        >
          <Icon path={mdiDotsVertical} size="1.25rem" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DocumentTagsDropdownMenuItem fragment={fragment} />
          <DocumentShareDropdownMenuItem fragment={fragment} />
          <DocumentRenameDropdownMenuItem fragment={fragment} />
          <DocumentExportDropdownMenuItem fragment={fragment} />
          <DocumentDeleteDropdownMenuItem fragment={fragment} />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
